








































import { Component, Prop } from "vue-property-decorator";
import { Mixins } from "vue-mixin-decorator";
import CtrlButton from "@/app/core/component/CtrlButton.vue";
import BaseInput from "@/app/core/component/BaseInput.vue";
import ComponentVue from "@/app/core/window/ComponentVue";
import { ResultInfo } from "@/app/basic/media/MediaUploadWindow.vue";

@Component({
  components: { BaseInput, CtrlButton }
})
export default class MediaUploadItemComponent extends Mixins<ComponentVue>(
  ComponentVue
) {
  @Prop({ type: Object, required: true })
  private resultInfo!: ResultInfo;
}
